import './ModalOptions.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import { toast } from "react-toastify";

export class ChangeMic extends Component {
    static displayName = ChangeMic.name;
    state = {
        itemChoice: 10,
    };


    componentDidMount() {
        //this.getCard();
    }


    doChoice = (e) => {
        e.preventDefault();
        let choice = cardService.getChoiceCard();
        if (choice == []) {
            toast.error('دستگاه فعال مشخص نشده است');;
            return;
        }
        utils.sendSms(choice.deviceNumber, `mic,${this.state.itemChoice}`)
        toast.dark('لطفا تا دریافت پیام از دستگاه صبر کنید');
        this.props.closeModal(e);
    }

    render() {
        let items = [];
        for (let i = 0; i < 15; i++)
            items.push(<li key={"i" + i}
                className={"list-group-item " + (this.state.itemChoice == i ? "list-group-item-dark" : "list-group-item-light")}
                onClick={(e) => this.setState({ itemChoice: i })}
            >
                <div className="d-flex justify-content-center">
                    {i}
                </div>
            </li>);
        return (
            <>
                <CustomModal show={this.props.showModal} onClose={(e) => { this.props.closeModal(e) }} >
                    <div className="row">
                        <div className="col">
                            <div className="d-flex justify-content-center">
                                لطفا مقدار مورد نظر را انتخاب بفرمایید
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <ul className="list-group" id="speedGroup">
                                {items}
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className=" d-flex justify-content-center" >
                                <a onClick={(e) => { this.doChoice(e) }}>
                                    <img src="images/accept.svg" className="imgButtonModal"></img>
                                </a>
                                <a onClick={(e) => this.props.closeModal(e)}>
                                    <img src="images/cancel.svg" className="imgButtonModal"></img>
                                </a>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </>
        );
    }


}